import React from 'react';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 1rem auto;
  padding: 0 2rem;
`;

const ProgressBarOuter = styled.div`
  width: 100%;
  height: 10px;
  background-color: #E0E0E0;
  border-radius: 5px;
  overflow: hidden;
`;

const ProgressBarInner = styled.div`
  height: 100%;
  background-color: #4169E1;
  border-radius: 5px;
  width: ${props => props.progress}%;
  transition: width 0.5s ease;
`;

const ProgressText = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #2C3E50;
`;

const ScoreText = styled.span`
  font-weight: bold;
  color: #4169E1;
`;

const ProgressBar = ({ currentQuestion, totalQuestions, score }) => {
  const progress = (currentQuestion / totalQuestions) * 100;
  
  return (
    <ProgressBarContainer>
      <ProgressBarOuter>
        <ProgressBarInner progress={progress} />
      </ProgressBarOuter>
      <ProgressText>
        <div>Ερώτηση {currentQuestion} από {totalQuestions}</div>
        <ScoreText>Σκορ: {score}/{currentQuestion - 1}</ScoreText>
      </ProgressText>
    </ProgressBarContainer>
  );
};

export default ProgressBar;
